import layout from "./layout";
import navbar from "./navbar";
import alerta from "./alerta.slice";

const rootReducer = { navbar, layout, alerta };

export default rootReducer;
